'use strict';

var React = require('react');

var SvgPaperCheckIcon = function SvgPaperCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.496 5.354a.5.5 0 0 0 0-.707l-1.06-1.061a.5.5 0 0 0-.707 0l-.957.957 1.767 1.768.957-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.832 7.018-1.768-1.768-2.449 2.45a2 2 0 0 0-.585 1.406l-.003.698a.25.25 0 0 0 .251.251l.698-.002a2 2 0 0 0 1.407-.586l2.45-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.25c0-.69.56-1.25 1.25-1.25h.25a.75.75 0 1 0 0-1.5h-.25a2.75 2.75 0 0 0-2.75 2.75v4a2.75 2.75 0 0 0 2.75 2.75h9a2.75 2.75 0 0 0 2.75-2.75v-4.25a2.5 2.5 0 0 0-2.5-2.5.75.75 0 0 0 0 1.5 1 1 0 0 1 1 1v4.25c0 .69-.56 1.25-1.25 1.25h-9c-.69 0-1.25-.56-1.25-1.25v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgPaperCheckIcon.displayName = "PaperCheckIcon";

exports.SvgPaperCheckIcon = SvgPaperCheckIcon;
